import {IAppContextState} from "./AppContext.interfaces";
import React from "react";

export const AppContext = React.createContext<IAppContextState>({} as any);